import React from "react";
import { Route, Routes } from "react-router-dom";
import { RoutesPaths } from "./constant";
import Dashboard from "../Pages/Dashboard";
import Customization from "../Pages/Customization";
import Billing from "../Pages/Billing";
import InstallSettings from "../Pages/InstallSettings";
import Conversations from "../Pages/Conversations";
import Analytics from "../Pages/Analytics";
import Assistant from "../Pages/Assistant";
import Integrations from "../Pages/Integrations";
import AccountSettings from "../Pages/AccountSettings";
import TrainingAssistant from "../Pages/TrainingAssistant";
import CheckOut from "../Pages/CheckOut";
import Login from "../Pages/Auth/Login";
import SignUp from "../Pages/Auth/SignUp";
import CreateAssistant from "../Pages/Auth/CreateAssistant";
import VerifyOtp from "../Pages/Auth/VerifyOtp";
import ForgotPassword from "../Pages/Auth/ForgotPassword";

export default function RouteComponent() {
  return (
    <>
      <Routes>
        <Route exact path={RoutesPaths.LOGIN} element={<Login />} />
        <Route exact path={RoutesPaths.SIGNUP} element={<SignUp />} />
        <Route
          exact
          path={RoutesPaths.CREATE_ASSISTANT}
          element={<CreateAssistant />}
        />
        <Route exact path={RoutesPaths.VERIFY_OTP} element={<VerifyOtp />} />
        <Route exact path={RoutesPaths.FORGOT_PASSWORD} element={<ForgotPassword />} />
        <Route exact path={RoutesPaths.DASHBOARD} element={<Dashboard />} />
        <Route exact path={RoutesPaths.CUSTOMIZATION} element={<Customization />} />
        <Route exact path={RoutesPaths.BILLING} element={<Billing />} />
        <Route exact path={RoutesPaths.INSTALL_SETTINGS} element={<InstallSettings />} />
        <Route exact path={RoutesPaths.CONVERSATIONS} element={<Conversations />} />
        <Route exact path={RoutesPaths.ANALYTICS} element={<Analytics />} />
        <Route exact path={RoutesPaths.ASSISTANT} element={<Assistant />} />
        <Route exact path={RoutesPaths.INTEGRATIONS} element={<Integrations />} />
        <Route exact path={RoutesPaths.ACCOUNT_SETTINGS} element={<AccountSettings />} />
        <Route exact path={RoutesPaths.TRAINING_BOT} element={<TrainingAssistant />} />
        <Route exact path={RoutesPaths.CHECKOUT} element={<CheckOut />} />
      </Routes>
    </>
  );
}
